<template>
  <div class="highLowTable_ctn" :style="style">
    <div class="highLowTable_titleRow highLowTable_titleRow--top roundedCorner-t-l roundedCorner-t-r">
      <div class="highLowTable-titleRow_content highLowTable_border--right">{{ $t('High BG Event') }}</div>
      <div class="highLowTable-titleRow_content">{{ $t('Low BG Event') }}</div>
    </div>  
    <div class="highLowTable_descriptionRow">
      <div class="highLowTable_descriptionRow--label">
        {{ $t('Time') }}
      </div>
      <div class="highLowTable_descriptionRow--content highLowTable_border--right">
        {{ $t('Number') }}
      </div>
      <div class="highLowTable_descriptionRow--label">
        {{ $t('Time') }}
      </div>
      <div class="highLowTable_descriptionRow--content">
        {{ $t('Number') }}
      </div>
    </div>
    <div class="highLowTable_descriptionRow">
      <div class="highLowTable_descriptionRow--label">
        {{ highEventArray[0] ? highEventArray[0]['time'] : '' }}
      </div>
      <div class="highLowTable_descriptionRow--content highLowTable_border--right">
        {{ highEventArray[0] ? highEventArray[0]['number'] : '' }}
      </div>
      <div class="highLowTable_descriptionRow--label">
        {{ lowEventArray[0] ? lowEventArray[0]['time'] : '' }}
      </div>
      <div class="highLowTable_descriptionRow--content">
        {{ lowEventArray[0] ? lowEventArray[0]['number'] : '' }}
      </div>
    </div>
    <div class="highLowTable_descriptionRow">
      <div class="highLowTable_descriptionRow--label">
        {{ highEventArray[1] ? highEventArray[1]['time'] : '' }}
      </div>
      <div class="highLowTable_descriptionRow--content highLowTable_border--right">
        {{ highEventArray[1] ? highEventArray[1]['number'] : '' }}
      </div>
      <div class="highLowTable_descriptionRow--label">
        {{ lowEventArray[1] ? lowEventArray[1]['time'] : '' }}
      </div>
      <div class="highLowTable_descriptionRow--content">
        {{ lowEventArray[1] ? lowEventArray[1]['number'] : '' }}
      </div>
    </div>
    <div class="highLowTable_descriptionRow roundedCorner-b-l roundedCorner-b-r ">
      <div class="highLowTable_descriptionRow--label roundedCorner-b-l">
        {{ highEventArray[2] ? highEventArray[2]['time'] : '' }}
      </div>
      <div class="highLowTable_descriptionRow--content highLowTable_border--right">
        {{ highEventArray[2] ? highEventArray[2]['number'] : '' }}
      </div>
      <div class="highLowTable_descriptionRow--label">
        {{ lowEventArray[2] ? lowEventArray[2]['time'] : '' }}
      </div>
      <div class="highLowTable_descriptionRow--content roundedCorner-b-r">
        {{ lowEventArray[2] ? lowEventArray[2]['number'] : '' }}
      </div>
    </div>            
  </div>  
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'

export default {
  name: 'CHighAndLowEventTable',
  mixins: [reDrawTrigger],
  props: {
    showMarginRight: {
      type: [Number, Boolean, String],
      default: true
    },
    highEventArray: {
      type: [Array],
      default: () => []
    },
    lowEventArray: {
      type: [Array],
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  computed: {
    h() {
      const dh = this.dh
      
      const r = 221 / 1240
      // console.error(`[bar]computed h: ${dh}, rst: ${r * dh}`)
      return r * dh
    },
    w() {
      const ds = this.ds
      
      const r = 455 / 1754
      // console.error(`[bar]computed w: ${ds}, rst: ${r * ds}`)
      return r * ds
    },
    style() {
      const { showMarginRight, zoomRatio } = this
      const rst = { zoom: zoomRatio }
      
      if (`${showMarginRight}`.toLowerCase().trim() !== `false` && showMarginRight) {
        rst.marginRight = Math.floor(zoomRatio * 20) + 'px'
      }
      return rst
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
@import '@/styles/variables';

.highLowTable_ctn {
    color: $colorGluMesurementFont;
    font-weight: 600;
    font-size: $sizeFontSize;
    display: inline-block;
    width: 520px;
    @include bBox;
    .highLowTable_titleRow {
        @include bBox;
        @include heightMiddle(44px);
        @include flexRow(flex-start, center);
        .highLowTable-titleRow_content {
            @include bBox;
            width: 50%;
            flex-shrink: 1;
            text-align: center;
        }
    }
    .highLowTable_border--right {
        border-right: 1px solid $colorGluMesurementInnerBorder;
    }
    .highLowTable_titleRow, .highLowTable_descriptionRow {
        @include bBox;
        @include heightMiddle(44px);
        overflow: hidden;
        /* min-height: 44px; */
        border: 1px solid $colorGluMesurementInnerBorder;
        border-top-width: 0;
        /* border-bottom-width: 0; */
        text-indent: 7px;
        &.highLowTable_titleRow--last {
            border-bottom: 1px solid $colorGluMesurementInnerBorder;
        }
        &.highLowTable_titleRow--top {
            text-indent: 20px;
            border-top-width: 1px;
            /* border-bottom-width: 1px; */
        }
    }
    .highLowTable_descriptionRow {
        @include flexRow;
        .highLowTable_descriptionRow--label, .highLowTable_descriptionRow--content {
            @include bBox;
            flex-grow: 1;
            flex-shrink: 1;
            height: 100%;
            min-height: 44px;
            width: 25%;
            @include flexColumn(center, center)
        }
        .highLowTable_descriptionRow--label {
            background-color: $colorGluMesurementLabelBg;
            color: $colorGluMesurementFont;
            padding: 0 5px;
            text-indent: 0;

            &.highLowTable_descriptionRow--label2 {
                width: 25%;
                flex-grow: 0;
                font-size: 0.92em;
            }
            &.highLowTable_descriptionRow--label3 {
                width: calc(263 / 455) * 100%;
                flex-grow: 0;
                font-size: 1em;
            }
        }
    }
}
</style>
